import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { toast } from 'react-toastify';
import queryString from 'query-string';

import LoadingCenter from '../../../Components/LoadingCenter';
import DateLabel from '../../../Components/DateLabel';
import NumberColor from '../../../Components/NumberColor';
import BackButtonRouter from '../../../Components/BackButtonRouter';
import StatusIcon from '../../../Components/StatusIcon';
import DeleteTag from '../../../Components/DeleteTag';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';
import OpenLink from '../../../Helper/OpenLink';
import InitSelect from '../../../Helper/InitSelect';

import Store from '../../../Helper/Store';
import StoreKey from '../../../StoreKey';

import AppConfig from '../../../AppConfig';
import AppColor from '../../../AppColor';

import FITTypeHelper from '../Helpers/FITTypeHelper';

import SEARCH_BY from '../../../StaticData/SearchBy';
import VISATYPES from '../../../StaticData/VISATypes';

import Search from './Search';
import SearchFilterContext from '../../../Context/SearchFilterContext';
import TravelerHelper from '../../../Helper/Traveler';
export default class JoinTourList extends Component {
	static contextType = SearchFilterContext;
	constructor(props) {
		super(props);
		const query = queryString.parse(props.location.search);
		const searchBy = query.searchBy && InitSelect(SEARCH_BY, query.searchBy) ? InitSelect(SEARCH_BY, query.searchBy) : SEARCH_BY[1];
		const status = Store.get(StoreKey.filter.status);
		// const fitCustomer = Store.get(StoreKey.filter.fitCustomer);
		// console.log('fitCustomer: ', fitCustomer);
		const fitType = Store.get(StoreKey.filter.fitType);
		const invoice = Store.get(StoreKey.filter.invoice);
		// const customerName = Store.get(StoreKey.filter.customerName);
		// const customerTelephone = Store.get(StoreKey.filter.customerTelephone);
		this.state = {
			isLoading: true,
			filter: {
				status: status
					? status
					: {
							value: '',
							label: 'All - ทั้งหมด',
					  },
				// fitCustomer: fitCustomer
				// 	? fitCustomer
				// 	: {
				// 			value: 0,
				// 			label: 'All - ทั้งหมด',
				// 	  },
				fitType: fitType
					? fitType
					: {
							value: '',
							label: 'All - ทั้งหมด',
					  },
				startDate: null,
				endDate: null,
				invoice: invoice ? invoice : '',
				searchBy,
				// customerName: customerName ? customerName : '',
				// customerTelephone: customerTelephone ? customerTelephone : '',
				travelerId: null,
				selectedTraveler: null,
				staffName: '',
			},
			code: '',
			programs: [],
			summary: {},
			initTravelers: [],
		};
	}

	async componentDidMount() {
		this.setState(
			state => ({
				filter: {
					...state.filter,
					...this.context,
				},
			}),
			async () => {
				await this.getPrograms();
				await this.getInitTravelers();
			}
		);
	}

	getPrograms = async () => {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			const toValidMoment = (value, fallback) => {
				if (!value) return fallback;
				// react-datepicker in this page uses moment values; guard against invalid/object/string edge cases.
				if (moment.isMoment(value)) {
					return value.isValid() ? value : fallback;
				}
				const parsed = moment(value);
				return parsed.isValid() ? parsed : fallback;
			};
			const fallbackStartDate = moment().subtract(14, 'd');
			const fallbackEndDate = moment();
			const normalizedStartDate = toValidMoment(this.state.filter.startDate, fallbackStartDate);
			const normalizedEndDate = toValidMoment(this.state.filter.endDate, fallbackEndDate);

			this.context.updateSearchFilter(this.state.filter);
			this.setState({
				isLoading: true,
			});

			Store.set(StoreKey.filter.status, this.state.filter.status);
			Store.set(StoreKey.filter.fitType, this.state.filter.fitType);
			// Store.set(StoreKey.filter.fitCustomer, this.state.filter.fitCustomer);
			Store.set(StoreKey.filter.invoice, this.state.filter.invoice);
			// Store.set(StoreKey.filter.customerName, this.state.filter.customerName);
			// Store.set(StoreKey.filter.customerTelephone, this.state.filter.customerTelephone);
			// Store.set(StoreKey.filter.staffName, this.state.filter.staffName);

			const startDate = normalizedStartDate.format('YYYY-MM-DD');
			const endDate = normalizedEndDate.format('YYYY-MM-DD');
			const fitTypeValue = this.state.filter.fitType && this.state.filter.fitType.value ? this.state.filter.fitType.value : '';
			const statusValue = this.state.filter.status && this.state.filter.status.value ? this.state.filter.status.value : '';
			const searchByValue = this.state.filter.searchBy && this.state.filter.searchBy.value ? this.state.filter.searchBy.value : SEARCH_BY[1].value;

			let filter = {
				startDate: startDate,
				endDate: endDate,
				fitType: fitTypeValue,
				// fitCustomerId: this.state.filter.fitCustomer.value,
				status: statusValue,
				invoice: this.state.filter.invoice,
				// customerName: this.state.filter.customerName,
				// customerTelephone: this.state.filter.customerTelephone,
				travelerId: this.state.filter.travelerId,
				searchBy: searchByValue,
				// staffName: this.state.filter.staffName,
			};

			let requestPrograms = APIGet('fit/programs', filter);
			let requestSummary = APIGet('fit', filter);
			requestPrograms = await requestPrograms;
			requestSummary = await requestSummary;
			if (APIHelper.handleAPIResponse(this, requestPrograms, requestSummary)) {
				const programs = requestPrograms.data;
				const summary = requestSummary.data;
				this.setState({
					isLoading: false,
					programs,
					summary,
				});
			} else {
				toast.error('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
			}
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	};

	getInitTravelers = async () => {
		let allTravelerResponse = [];
		const request = await APIGet('travelers?page=1&perPage=40');
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			allTravelerResponse = Array.isArray(responseData) ? responseData : responseData.data || [];
		} else if (request.status === 404) {
			// toast.warning('ไม่พบข้อมูล Traveler');
		} else {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ทั้งหมดได้กรุณาลองใหม่อีกครั้ง');
			return;
		}

		this.setState({
			initTravelers: allTravelerResponse,
		});

		// return allTravelerResponse;
	};

	clearSearch = () => {
		const startDate = moment().subtract(14, 'd');
		const endDate = moment();
		this.setState(
			{
				filter: {
					// fitCustomer: {
					// 	value: 0,
					// 	label: 'All - ทั้งหมด',
					// },
					fitType: {
						value: '',
						label: 'All - ทั้งหมด',
					},
					startDate,
					endDate,
					invoice: '',
					searchBy: SEARCH_BY[1],
					// customerName: '',
					// customerTelephone: '',
					travelerId: null,
					selectedTraveler: null,
					status: {
						value: '',
						label: 'All - ทั้งหมด',
					},
					staffName: '',
				},
			},
			() => {
				this.getPrograms();
			}
		);
	};

	onFilterChange = (name, value) => {
		this.setState(prevState => ({
			filter: {
				...prevState.filter,
				[name]: value,
			},
		}));
	};

	/** Country / visa type labels from fit visa line items (list API may nest relations or send ids only). */
	getFitVisaCountryAndTypeDisplay = program => {
		const visaItems = (program.fitItems || []).filter(i => i && i.fitType === 'fitVisa');
		// console.log(`visaItems: `, visaItems);
		if (visaItems.length === 0) {
			return { countriesText: '—', visaTypesText: '—' };
		}

		const firstVisaItem = visaItems[0];
		const countriesText =
			firstVisaItem && firstVisaItem.fitVisa && firstVisaItem.fitVisa.country && firstVisaItem.fitVisa.country.name
				? firstVisaItem.fitVisa.country.name
				: '—';
		let visaTypesText = '—';
		const visaType = firstVisaItem && firstVisaItem.fitVisa && firstVisaItem.fitVisa.visaType ? firstVisaItem.fitVisa.visaType : '';
		if (visaType) {
			VISATYPES.forEach(type => {
				if (type.value === visaType) {
					visaTypesText = type.label;
				}
			});
		}

		return { countriesText, visaTypesText };
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		const { summary, programs } = this.state;
		return (
			<div className="container">
				<BackButtonRouter link={AppConfig.appPath + '/'} title="ดูทั้งหมด" />
				<div className="columns">
					<div className="column is-6">
						<h2 className="title is-2">FIT</h2>
					</div>
					<div className="column is-6" style={{ textAlign: 'right' }}>
						<Link className="button is-success" to={`${AppConfig.appPath}/programs/newfit`}>
							เพิ่มรายการ
						</Link>
					</div>
				</div>
				<Search
					{...this.state.filter}
					onFilterChange={this.onFilterChange}
					search={this.getPrograms}
					clearSearch={this.clearSearch}
					initTravelers={this.state.initTravelers}
				/>
				<br />
				<div className="table-container row">
					<table className="table is-hoverable is-fullwidth is-striped is-bordered">
						<thead>
							<tr className="table-header">
								<td rowSpan={2} width="12%">
									วันจอง
								</td>
								<td rowSpan={2}>Invoice</td>
								<td rowSpan={2}>Types</td>
								<td colSpan={3} style={{ textAlign: 'center' }}>
									รายการ
								</td>
								<td rowSpan={2} width="18%">
									พนักงาน
								</td>
								<td rowSpan={2} width="5%">
									ราคา
								</td>
								<td rowSpan={2} width="5%">
									รายจ่าย
								</td>
								<td rowSpan={2} width="5%">
									กำไร
								</td>
								<td rowSpan={2} width="10%">
									รับชำระมาแล้ว
								</td>
							</tr>
							<tr className="table-header">
								<td width="9%">ชื่อลูกค้า</td>
								<td width="9%">ประเทศที่ยื่น visa</td>
								<td width="9%">ประเภทวีซ่า</td>
							</tr>
						</thead>
						<tbody>
							{programs.map(program => {
								if (!program.traveler) return null;
								const { countriesText, visaTypesText } = this.getFitVisaCountryAndTypeDisplay(program);
								return (
									<tr key={'program' + program.id}>
										<td>
											<DateLabel date={program.created_at} />
										</td>
										<td>
											{program.invoice ? (
												<a onClick={() => OpenLink.fitInvoice(program.invoice.id)}>{program.invoice.documentNumber}</a>
											) : (
												''
											)}
											<StatusIcon status={program.status} deletedAt={program.deleted_at} />{' '}
											<span style={{ color: 'red', fontSize: 10 }}>
												{program.deleted_by_user_name ? program.deleted_by_user_name : null}
											</span>
										</td>
										<td>
											{program.fitItems &&
												program.fitItems.map(item => (
													<span
														className="tag"
														key={'type-' + item.id}
														style={{ marginRight: 2, backgroundColor: AppColor.fitType[item.fitType] }}
													>
														{FITTypeHelper.mapLabel(item.fitType)}
													</span>
												))}
										</td>
										<td>
											<Link to={AppConfig.appPath + '/programs/fit/' + program.id}>
												{program.traveler ? TravelerHelper.getFullName(program.traveler) : '—'}
											</Link>{' '}
										</td>
										<td style={{ fontSize: 13, verticalAlign: 'top' }}>{countriesText}</td>
										<td style={{ fontSize: 13, verticalAlign: 'top' }}>{visaTypesText}</td>
										<td>
											{program.staffs && program.staffs.length > 0 ? (
												<div>
													{program.staffs.map(staff => {
														if (staff && staff.staff) {
															return <div key={'staff-' + staff.staff.id}>- {staff.staff.nickname}</div>;
														}
														return null;
													})}
												</div>
											) : null}
										</td>
										<td className="number-cell">
											<NumberColor number={program.salePrice + program.creditCharge} />
										</td>
										<td className="number-cell">
											<NumberColor number={program.expense + program.price + program.creditCharge} isExpense={true} />
										</td>
										<td className="number-cell">
											<NumberColor number={program.salePrice - program.expense - program.price} />
										</td>
										<td className="number-cell">
											<NumberColor number={program.paid} />
										</td>
									</tr>
								);
							})}
							<tr className="table-summary-row">
								<td colSpan={7} style={{ textAlign: 'center' }}>
									Summary
								</td>
								<td className="number-cell">
									<NumberColor number={summary.totalSalePrice + summary.totalCreditCharge} />
								</td>
								<td className="number-cell">
									<NumberColor number={summary.totalExpense + summary.totalPrice + summary.totalCreditCharge} isExpense={true} />
								</td>
								<td className="number-cell">
									<NumberColor number={summary.totalSalePrice - summary.totalExpense - summary.totalPrice} />
								</td>
								<td className="number-cell">
									<NumberColor number={summary.totalPaid} />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<br />
			</div>
		);
	}
}
